<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5">
          <!-- 2FA Setup Modal -->
          <b-modal
            v-if="setup2fa"
            v-model="setup2fa"
            title="Two-Factor Authentication Required"
            size="lg"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            centered
          >
            <template #modal-header="{ titleClass }">
              <div class="d-flex align-items-center w-100">
                <i class="fa fa-shield text-primary mr-2 fa-lg" />
                <h5
                  :class="titleClass"
                  class="mb-0"
                >
                  Two-Factor Authentication Setup
                </h5>
              </div>
            </template>
            
            <div class="text-center mb-4">
              <b-alert
                show
                variant="info"
                class="mb-3"
              >
                <i class="fa fa-info-circle" />
                <strong>Security Required:</strong> All users must complete 2FA setup to access the system.
              </b-alert>
            </div>

            <form @submit.prevent="validateOTP">
              <div class="setup-steps">
                <div class="step mb-4">
                  <div class="d-flex align-items-start">
                    <div
                      class="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
                      style="min-width: 32px; height: 32px; font-weight: bold;"
                    >
                      1
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-2">
                        Install an Authenticator App
                      </h6>
                      <p class="mb-3 text-muted">
                        Download one of these apps on your mobile device:
                      </p>
                      <div class="app-links">
                        <b-button
                          variant="outline-success"
                          size="sm"
                          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                          target="_blank"
                          class="mr-2 mb-2"
                        >
                          <i class="fa fa-android mr-1" /> Android
                        </b-button>
                        <b-button
                          variant="outline-dark"
                          size="sm"
                          href="https://itunes.apple.com/gb/app/google-authenticator/id388497605"
                          target="_blank"
                          class="mr-2 mb-2"
                        >
                          <i class="fa fa-apple mr-1" /> iOS
                        </b-button>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          href="https://www.microsoft.com/en-gb/store/p/microsoft-authenticator/9nblgggzmcj6"
                          target="_blank"
                          class="mr-2 mb-2"
                        >
                          <i class="fa fa-windows mr-1" /> Windows
                        </b-button>
                        <b-button
                          variant="outline-primary"
                          size="sm"
                          href="https://support.1password.com/one-time-passwords/?linux#save-your-one-time-password-code"
                          target="_blank"
                          class="mb-2"
                        >
                          <i class="fa fa-key mr-1" /> 1Password
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="step mb-4">
                  <div class="d-flex align-items-start">
                    <div
                      class="step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
                      style="min-width: 32px; height: 32px; font-weight: bold;"
                    >
                      2
                    </div>
                    <div class="flex-grow-1 text-center">
                      <h6 class="mb-3">
                        Scan this QR Code
                      </h6>
                      <div class="qr-code-container d-flex justify-content-center mb-1">
                        <div class="p-3 bg-white border rounded shadow-sm">
                          <qriously
                            :value="otpauth"
                            :size="200"
                          />
                        </div>
                      </div>
                      <small class="text-muted">{{ secretKey }}</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-between mt-4 pt-3 border-top">
                <b-button
                  variant="outline-secondary"
                  @click="$router.push('/login')"
                >
                  <i class="fa fa-arrow-left mr-1" /> Back to Login
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                >
                  Continue <i class="fa fa-arrow-right ml-1" />
                </b-button>
              </div>
            </form>
          </b-modal>
        </div>
      </div>
    </div>
    
    <footer class="login-footer">
      <img
        src="static/img/labs_logo.svg"
        class="labs-logo login center-block"
        alt="labs-img"
      >
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as Routes from '../constants/routes'

export default {
  name: 'QRCode',
  
  data() {
    return {
      setup2fa: true,
      secret: ''
    }
  },
  
  computed: {
    ...mapGetters([
      'secretKey',
      'username', 
      'otpauth'
    ])
  },
  
  mounted() {
    // Focus management for accessibility
    this.$nextTick(() => {
      const modal = this.$refs.setupModal
      if (modal) {
        modal.$el.focus()
      }
    })
  },
  
  methods: {
    validateOTP(event) {
      event.preventDefault()
      this.$router.push(Routes.ONE_TIME_PWD)
    },
    
    handleBackToLogin() {
      this.$router.push(Routes.LOGIN)
    }
  }
}
</script>
